// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"97c3b356","901":"db479dc6"}[chunkId] + ".chunk.js";
};